import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import About from "./pages/About";
import StarPage from './pages/StarPage';
import PlanetPage from "./pages/PlanetPage";
import GalaxyPage from "./pages/GalaxyPage";
import SatellitePage from "./pages/SatellitePage";

import CelestialDetails from "./pages/CelestialDetails";
import Explore from "./pages/Explore";
import Contact from "./pages/Contact";

function App() {
  return (
    <Router>
      {/* .stars is handled by CSS, providing the visual background */}
      <div className="stars"></div>
      
      {/* Main App Container: Ensures the whole app takes up the screen height and has a base dark background */}
      {/* <div className="flex flex-col min-h-screen bg-[#050610] font-sans"> */}
        <Navbar />
        {/* main: flex-grow ensures this section takes all remaining vertical space */}
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/details" element={<CelestialDetails />} />
            <Route path="/explore" element={<Explore />} />
            <Route path="/stars" element={<StarPage />} />
            <Route path="/planets" element={<PlanetPage/>}/>
            <Route path="/galaxies" element={<GalaxyPage/>}/>
            <Route path="/satellites" element={<SatellitePage/>}/>
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
        
        
      {/* </div> */}
    </Router>
  );
}

export default App;
